import { getDomain } from 'tldts';

const hostname = window.location.hostname;

const domain = getDomain(hostname);

export const ASSETS_URL = `https://assets.${domain}/`;